import { forwardRef } from 'react';

import { Footer } from './Footer';
import { FooterSlots } from './FooterSlots';
import type { FooterVariant, RootFooterProps } from './types';

const FooterNamespace = Footer as typeof Footer & {
  Socials: typeof FooterSlots.Socials;
  TopSection: typeof FooterSlots.TopSection;
} & Record<
    FooterVariant,
    React.ForwardRefExoticComponent<
      Omit<RootFooterProps, 'ref' | 'variant'> &
        React.RefAttributes<HTMLDivElement>
    >
  >;

FooterNamespace.MCosmetic = forwardRef<
  HTMLDivElement,
  Omit<RootFooterProps, 'variant'>
>(({ children, ...props }, ref) => (
  <Footer {...props} variant="MCosmetic" ref={ref}>
    {children}
  </Footer>
));

FooterNamespace.Socials = FooterSlots.Socials;
FooterNamespace.TopSection = FooterSlots.TopSection;

export { FooterNamespace as Footer, FooterSlots };
